import styled from 'styled-components';
import { baseVariables } from '../../styles';

interface WrapperProps {
  $imageOverlay: boolean;
  $iconOnly: boolean;
}

export const Wrapper = styled.button<WrapperProps>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $iconOnly, $imageOverlay }) => {
    if ($iconOnly) {
      return `${baseVariables.spacers?.spacers?.[2] ?? '0.5rem'}`;
    }
    if ($imageOverlay) {
      return `${baseVariables.spacers?.spacers?.[2] ?? '0.5rem'} ${baseVariables.spacers?.spacers?.[3] ?? '1rem'}`;
    }
    return `0 ${baseVariables.spacers?.spacers?.[3] ?? '1rem'}`;
  }};
  background-color: ${({ $imageOverlay }) =>
    $imageOverlay ? 'var(--t-color-control-background-overlay, rgba(255, 255, 255, 0.52))' : 'transparent'};
  backdrop-filter: ${({ $imageOverlay }) => ($imageOverlay ? 'blur(4px)' : 'none')};
  -webkit-backdrop-filter: ${({ $imageOverlay }) => ($imageOverlay ? 'blur(4px)' : 'none')};
  border: ${({ $iconOnly, $imageOverlay }) =>
    $iconOnly && !$imageOverlay
      ? `1px solid var(--t-color-control-foreground-reverse, ${baseVariables.color.base10})`
      : 'none'};
  border-radius: ${({ $iconOnly }) => ($iconOnly ? '44px' : 'var(--t-border-radius-pill, 9999px)')};
  color: var(--t-color-control-foreground-reverse, ${baseVariables.color.base10});
  cursor: pointer;
  overflow: hidden;

  &:disabled {
    opacity: var(--t-button-disabled-opacity, 0.5);
    pointer-events: none;
  }

  &:focus-visible {
    outline: 2px solid -webkit-focus-ring-color;
    outline-offset: 2px;
  }
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${baseVariables.spacers?.spacers?.[2] ?? '0.5rem'};
  color: inherit;

  .icon::before {
    color: inherit;
  }
`;

export const Text = styled.span`
  font: normal normal 700 var(--t-font-m-font-size-viewport-xs, 0.8125rem) / 1 var(--t-base-font-family);
  color: inherit;
  white-space: nowrap;
`;
